import { Component, OnDestroy, OnInit } from '@angular/core';
import { ListJobDutiesService } from 'list-job-duties';
import { ImmigrationWizardService } from '../services/immigration-wizard.service';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-itinerary-of-services',
  templateUrl: './itinerary-of-services.component.html',
  styleUrls: ['./itinerary-of-services.component.scss']
})

export class ItineraryOfServicesComponent implements OnInit, OnDestroy  {
  inputData: any;
  wizardInput: any;
  jobPositionTitle: any;
  isDataLoaded: boolean = false;
  observableSubscription$ = new Subject();

  constructor( public listJobDutiesService:ListJobDutiesService, 
    public immigrationWizardService: ImmigrationWizardService) {
  }

  ngOnInit(): void {
    this.immigrationWizardService.getWizardTaskDetails$().subscribe((res: any) => {
      if(res){
        this.inputData = {
          "superTaskId": res.superTaskId,
          "subTaskId": res.id,
          "caseType": res.subTaskTypeCode,
          "caseId": res.petitionId,
          "petitionId": res.petitionId,
          "foreignCompanyId": null,
          "visatype": res.taskTypeDetails.visaType,
          "visaName": res.taskTypeDetails.visaName,
          "petitionType": res.taskTypeDetails.petitionType,
          "immSpecialistId": res.immSpecialistId,
          "attorneyId": res.attorneyId,
          "sponsorId": res.sponsorId,
          "familyId": res.familyId,
          "immigrationCategory": null,
          "immigrationCategoryName": null,
          "immigrationClassification": null,
          "immigrationClassificationName": null,
          "superTaskTypeCode": res.superTaskTypeCode,
          "getTaskType": res.taskTypeDetails.visaType,
          "jsonInput": null,
          "beneficiaryId": res.beneficiaryId,
          "relationshipCode": null,
          "taskTypeId": res.taskTypeId,
          "taskTypeSaveJsonId": null,
          "companyId": res.companyId,
          "petitionerId": res.taskStepDetails[0].petitionerId,
          "stepName": "Generate Letters",
          "layoutCode": "FILL_FORM",
          "taskId": res.taskStepDetails[0].taskId,
          "isCustomStep": false,
        }
        this.wizardInput = {
          title: 'Itinerary of Services',
          data: {
            taskId: res?.superTaskId,
            individual: res?.beneficiaryDetails?.firstName+" "+res?.beneficiaryDetails?.lastName,
            petitionType: res?.taskTypeDetails?.petitionType,
            status: res?.taskStatus?.name
          }
        }
        this.isDataLoaded = true; 
      }
    });
  }

  ngOnDestroy() {
    this.observableSubscription$.next();
    this.observableSubscription$.complete();
  }
}
